import { render, staticRenderFns } from "./TagsColumn.vue?vue&type=template&id=d925d0a8"
import script from "./TagsColumn.vue?vue&type=script&lang=js"
export * from "./TagsColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports